// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/core-js/modules/es6.reflect.own-keys.js
// module id = ../../../../core-js/modules/es6.reflect.own-keys.js
// module chunks = 0